module.exports = __webpack_public_path__ + "img/progress_048.d759856a.png";